import React from "react";
import Select from "react-select";

export const StatesArray = [
    { Abbr: "AK", Full: "Alaska" },
    { Abbr: "AL", Full: "Alabama" },
    { Abbr: "AR", Full: "Arkansas" },
    { Abbr: "AS", Full: "American Samoa" },
    { Abbr: "AZ", Full: "Arizona" },
    { Abbr: "CA", Full: "California" },
    { Abbr: "CO", Full: "Colorado" },
    { Abbr: "CT", Full: "Connecticut" },
    { Abbr: "DC", Full: "DC" },
    { Abbr: "DE", Full: "Delaware" },
    { Abbr: "FL", Full: "Florida" },
    { Abbr: "GA", Full: "Georgia" },
    { Abbr: "GU", Full: "Guam" },
    { Abbr: "HI", Full: "Hawaii" },
    { Abbr: "IA", Full: "Iowa" },
    { Abbr: "ID", Full: "Idaho" },
    { Abbr: "IL", Full: "Illinois" },
    { Abbr: "IN", Full: "Indiana" },
    { Abbr: "KS", Full: "Kansas" },
    { Abbr: "KY", Full: "Kentucky" },
    { Abbr: "LA", Full: "Louisiana" },
    { Abbr: "MA", Full: "Massachusetts" },
    { Abbr: "MD", Full: "Maryland" },
    { Abbr: "ME", Full: "Maine" },
    { Abbr: "MI", Full: "Michigan" },
    { Abbr: "MN", Full: "Minnesota" },
    { Abbr: "MO", Full: "Missouri" },
    { Abbr: "MP", Full: "N. Marianas" },
    { Abbr: "MS", Full: "Mississippi" },
    { Abbr: "MT", Full: "Montana" },
    { Abbr: "NC", Full: "N. Carolina" },
    { Abbr: "ND", Full: "N. Dakota" },
    { Abbr: "NE", Full: "Nebraska" },
    { Abbr: "NH", Full: "New Hampshire" },
    { Abbr: "NJ", Full: "New Jersey" },
    { Abbr: "NM", Full: "New Mexico" },
    { Abbr: "NV", Full: "Nevada" },
    { Abbr: "NY", Full: "New York" },
    { Abbr: "OH", Full: "Ohio" },
    { Abbr: "OK", Full: "Oklahoma" },
    { Abbr: "OR", Full: "Oregon" },
    { Abbr: "PA", Full: "Pennsylvania" },
    { Abbr: "PR", Full: "Puerto Rico" },
    { Abbr: "RI", Full: "Rhode Island" },
    { Abbr: "SC", Full: "S. Carolina" },
    { Abbr: "SD", Full: "S. Dakota" },
    { Abbr: "TN", Full: "Tennessee" },
    { Abbr: "TX", Full: "Texas" },
    { Abbr: "UM", Full: "Outlying Islands" },
    { Abbr: "UT", Full: "Utah" },
    { Abbr: "VA", Full: "Virginia" },
    { Abbr: "VI", Full: "Virgin Islands" },
    { Abbr: "VT", Full: "Vermont" },
    { Abbr: "WA", Full: "Washington" },
    { Abbr: "WI", Full: "Wisconsin" },
    { Abbr: "WV", Full: "W. Virginia" },
    { Abbr: "WY", Full: "Wyoming" },
];

export function exists(value) {
  return StatesArray.some((obj) => obj.Abbr === value);
}

const statesOptions = (full = true) =>
  StatesArray.map((s) => ({
    value: s.Abbr,
    label: full ? s.Full : s.Abbr,
  }));

class StateSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: props.value ?? "" }; // store Abbr string
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value ?? "" });
        }
    }

    onChange = (option) => {
        const nextValue = option?.value ?? ""; // option is null when cleared
        if (this.props.value !== nextValue) {
            this.setState({ value: nextValue }, () => {
                this.props.onChange?.(nextValue, option);
            });
        }
    };

    render() {
        const opts = statesOptions(this.props.full);
        const selected = opts.find((o) => o.value === this.state.value) ?? null;

        return (
            <Select
                inputId={this.props.id}
                name={this.props.name}
                className={this.props.className}
                classNamePrefix="react-select"
                placeholder=""
                options={opts}
                value={selected}
                onChange={this.onChange}
                isClearable={this.props.isClearable ?? false}
            />
        );
    }
}

export default StateSelect;
